import  { useState } from 'react';
import { Container, TextField, Button, Typography, IconButton, Paper, Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Header from './Header';
const ReleasePlannerForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    version: '',
    description: '',
    releases: [{ name: '', repo_link: '', tag: '', release_document: '', note: '', description: '' }],
  });

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleReleaseChange = (index: any, event: any) => {
    const { name, value } = event.target;
    const updatedReleases: any = [...formData.releases];
    updatedReleases[index][name] = value;
    setFormData({ ...formData, releases: updatedReleases });
  };

  const addRelease = () => {
    setFormData({
      ...formData,
      releases: [
        ...formData.releases,
        { name: '', repo_link: '', tag: '', release_document: '', note: '', description: '' },
      ],
    });
  };

  const removeRelease = (index: any) => {
    const updatedReleases = [...formData.releases];
    updatedReleases.splice(index, 1);
    setFormData({ ...formData, releases: updatedReleases });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log('Submitted Data:', formData);
  };

  const formComp = () => {
    return (
      <Container maxWidth="md">
        <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
          <Typography variant="h5" gutterBottom>
            Release Plan Editor
          </Typography>
          <form onSubmit={handleSubmit}>
            {/* Name Field */}
            <TextField
              fullWidth
              label="Application Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              margin="normal"
              required
            />

            {/* Version Field */}
            <TextField
              fullWidth
              label="Version"
              name="version"
              value={formData.version}
              onChange={handleChange}
              margin="normal"
              required
            />

            {/* Description Field */}
            <TextField
              fullWidth
              label="Application Description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              margin="normal"
              multiline
              rows={3}
            />

            {/* Releases Section */}
            <Typography variant="h6" style={{ marginTop: '20px' }}>
              Releases
            </Typography>
            {formData.releases.map((release, index) => (
              <Paper key={index} elevation={2} style={{ padding: '15px', margin: '10px 0' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Service Name"
                      name="name"
                      value={release.name}
                      onChange={(event) => handleReleaseChange(index, event)}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Repository Link"
                      name="repo_link"
                      value={release.repo_link}
                      onChange={(event) => handleReleaseChange(index, event)}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Tag"
                      name="tag"
                      value={release.tag}
                      onChange={(event) => handleReleaseChange(index, event)}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Release Document Link"
                      name="release_document"
                      value={release.release_document}
                      onChange={(event) => handleReleaseChange(index, event)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Release Description"
                      name="description"
                      value={release.description}
                      onChange={(event) => handleReleaseChange(index, event)}
                      multiline
                      rows={2}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Note"
                      name="note"
                      value={release.note}
                      onChange={(event) => handleReleaseChange(index, event)}
                      multiline
                      rows={2}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: 'right' }}>
                    <IconButton onClick={() => removeRelease(index)} color="error" disabled={formData.releases.length === 1}>
                      <RemoveIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Paper>
            ))}

            {/* Add Release Button */}
            <Button
              startIcon={<AddIcon />}
              onClick={addRelease}
              color="primary"
              variant="contained"
              style={{ marginTop: '10px' }}
            >
              Add Release
            </Button>

            {/* Submit Button */}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              href={`data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(formData))}`}
              download="filename.json"
              fullWidth
              style={{ marginTop: '20px' }}
            >
              Download Release Plan
            </Button>
          </form>
        </Paper>
      </Container>
    );
  };
  return (
    <>
      <Header>
        <Grid sx={{ paddingTop: 2, alignContent: 'center' }}>
          <center>
            <Button variant="contained" sx={{ marginLeft: 2 }} href={'/release-planner'}>
              Planner
            </Button>
          </center>
        </Grid>

        {formComp()}
      </Header>
    </>
  );
};

export default ReleasePlannerForm;
